<template>
  <div class="table">
    <table class="fa-table" v-for="(d, rowId) in dataset" :key="d.id">
      <thead :style="{ backgroundColor: showColor ? d.color : null }">
        <td class="tx-wg-bold">{{ d.title[$i18n.locale] }}</td>
      </thead>
      <tbody v-if="d.items">
        <tr
          v-for="(item, itemId) in d.items"
          :key="item.id"
          :class="isBold(item.bold)"
          :style="{ color: showColor ? item.color : null }"
        >
          <div class="item-label">
            <td>{{ item.title[$i18n.locale] }}</td>
          </div>
          <div class="item-values">
            <td>{{ item.value | currency }}</td>
            <td v-if="passedYears">
              {{ passedYears[rowId].items[itemId].value | currency }}
            </td>
          </div>
        </tr>
        <tr :style="{ color: showColor ? d.color : '#3ec7e0' }">
          <div class="item-label">
            <td class="tx-wg-bold">{{ $t('total') }}</td>
          </div>
          <div class="item-values">
            <td class="tx-wg-bold">{{ d.value | currency }}</td>
            <td v-if="passedYears" class="tx-wg-bold">
              {{ passedYears[rowId].value | currency }}
            </td>
          </div>
        </tr>
      </tbody>
    </table>
    <div class="total" v-if="showTotal">
      <p class="tx-wg-bold">{{ $t('distributed-value') }}</p>
      <p class="tx-wg-bold">{{ total | currency }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Table',
  props: {
    data: {
      type: [Array, Object],
      require: true
    },
    showTotal: {
      type: Boolean,
      default: false
    },
    showColor: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    dataset() {
      if (Array.isArray(this.data)) return this.data;
      return this.data[this.$config.year];
    },
    passedYears() {
      return this.data[this.$config.year - 1];
    },
    total() {
      return this.dataset.reduce((acc, curr) => {
        return (acc += curr.value);
      }, 0);
    }
  },
  methods: {
    isBold(val) {
      return val ? 'tx-wg-bold' : null;
    }
  }
};
</script>

<style lang="scss" scoped>
.total {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 0.5rem;
  border-radius: 10px;
  border: 2px solid $col-blue-light;
  color: $col-blue-light;
}
table {
  margin-bottom: 1rem;
  &,
  thead,
  tbody {
    display: block;
  }
  tr {
    display: flex;
    flex-direction: row;
    align-content: space-between;
    line-height: 180%;
    color: $col-navy-dark;
    @media screen and (max-width: $mq-mobile) {
      line-height: 140%;
    }
    @media screen and (max-width: $mq-mobile) {
      line-height: 160%;
    }
    .item-label {
      width: 60%;
      text-align: left;
    }
    .item-values {
      display: flex;
      flex-direction: row;
      width: 40%;
      td:not(:only-child) {
        width: 50%;
        text-align: right;
      }
      td:only-child {
        width: 100%;
        text-align: right;
      }
    }
    td {
      display: block;
      padding: 0 1rem;
      @media screen and (max-width: $mq-mobile) {
        padding: 0 0.4rem;
      }
    }
  }
  thead {
    @include centered(false, true, column);
    background-color: $col-blue-light;
    min-height: 2.5rem;
    margin: 0.5rem 0;
    padding: 0 1rem;
    border-radius: 10px;
    color: $col-white;
    text-transform: uppercase;
    @media screen and (max-width: $mq-mobile) {
      padding: 0 0.5rem;
      font-size: 0.75rem;
      margin: 0.2rem 0;
    }
  }
}
</style>
